import type { UpdateOrderStatusDTO } from 'ecosystem'
import { fetchPropsFactory, storefrontApiCall } from '../../utils/fetching'
import { INVOICE_ORDERS_ENDPOINT } from './constants'

export interface UpdateInvoiceOrderStatusParams {
  orderNumber: string
  payload: UpdateOrderStatusDTO
}

export async function updateInvoiceOrderStatus(params: UpdateInvoiceOrderStatusParams) {
  const url = `${INVOICE_ORDERS_ENDPOINT}/${params.orderNumber}/status`
  const props = fetchPropsFactory({
    props: {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(params.payload)
    }
  })

  return storefrontApiCall<null>(url, props)
}
